import classnames from 'classnames'
import * as React from 'react'

const styles = require('./styles')

export interface Props {
  imageUrl?: string
}

const PendingOriginatorImage = ({ imageUrl }: Props) =>
  imageUrl !== undefined ? (
    <div className={styles.originators}>
      <img className={styles.transparentLogo} src={imageUrl} />
      <div className={styles.opacity}>
        <img src={imageUrl} />
      </div>
    </div>
  ) : null

export default PendingOriginatorImage
